export enum MenuOptionTypeEnum {
	DROPDOWN = 'menu.dropdown',
	ITEM_LINK = 'menu.menu-item-link',
	BUTTON = 'menu.menu-button',
}
